<script setup>
import { computed } from 'vue'

const props = defineProps({
    active: {
        type: Boolean,
        required: false,
        default: true,
    },
    expanded: {
        type: Set,
        required: true,
    },
    value: {
        required: true,
    },
})

const emit = defineEmits(['update:expanded'])

function toggle() {
    const updated = new Set(props.expanded)
    if (updated.has(props.value)) {
        updated.delete(props.value)
    } else {
        updated.add(props.value)
    }
    emit('update:expanded', updated)
}

const open = computed(() => props.expanded.has(props.value))
</script>
<template>
    <td @click="toggle()" :class="{ toggle: true, active, open }">
        <!-- expand/collapse here -->
        <i class="material-icons" v-if="active">chevron_right</i>
    </td>
</template>
<style scoped>
.toggle {
    user-select: none;
    width: 24px;
}

.active {
    cursor: pointer;
    padding: 0;
}

.active i {
    transform: rotate(0deg);
    transition: transform 0.1s;
}

.active.open i {
    transform: rotate(90deg);
}
</style>
